import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "login",
    props: true,
    component: () =>
      import(/* webpackChunkName: "conversation" */ "../views/LoginView.vue"),
  },
  {
    path: "/auth/callback",
    name: "authCallback",
    component: () =>
      import(
        /* webpackChunkName: "auth-callback" */ "../views/AuthCallbackView.vue"
      ),
  },
  {
    path: "/",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "HomeView" */ "../views/HomeView.vue"),
    children: [
      {
        path: "",
        name: "home",
        component: () =>
          import(/* webpackChunkName: "chat" */ "../views/ChatView.vue"),
      },
      {
        path: "services",
        name: "services",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "services" */ "../views/ServicesView.vue"
          ),
        meta: { requiresAuth: true },
      },
      {
        path: "requests",
        name: "requests",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "requests" */ "../views/RequestsView.vue"
          ),
        meta: { requiresAuth: true },
      },
      {
        path: "call-history",
        name: "callHistory",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "call-history" */ "../views/CallHistoryView.vue"
          ),
        meta: { requiresAuth: true },
      },
      {
        path: "osint-search",
        name: "osintSearch",
        props: true,
        component: () =>
          import(
            /* webpackChunkName: "osint-search" */ "../views/OsintSearchView.vue"
          ),
        meta: { requiresAuth: true },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
